import React from 'react';
import { Link } from 'react-router-dom';
import withSounds from 'containers/withSounds';
import { isAdmin, isWccSupportUser } from 'utils/roles';
import icon from './icon-wc-logo.svg';
import './HomeIcon.css';

const {
  REACT_APP_JENKINS_BUILD_TAG,
  REACT_APP_JENKINS_BUILD_VERSION,
  REACT_APP_JENKINS_GIT_COMMIT,
  REACT_APP_JENKINS_BUILD_TIME_Chicago,
  REACT_APP_JENKINS_BUILD_TIME_UTC
} = process.env;

const versionInfoMap = {
  Version: REACT_APP_JENKINS_BUILD_VERSION,
  'Build Tag': REACT_APP_JENKINS_BUILD_TAG,
  'Git Commit': REACT_APP_JENKINS_GIT_COMMIT,
  'Build Time (Chicago)': REACT_APP_JENKINS_BUILD_TIME_Chicago,
  'Build Time (UTC)': REACT_APP_JENKINS_BUILD_TIME_UTC
};

let versionInfo = '';

Object.keys(versionInfoMap).forEach(label => {
  if (versionInfoMap[label]) {
    versionInfo += `${label}: ${versionInfoMap[label]}\n`;
  }
});

if (versionInfo.length > 0) {
  versionInfo = `Current Build Info\n\n${versionInfo}`;
}

function HomeIcon({ user, onClick }) {
  return (
    <div className="home-icon">
      <Link
        to="/"
        onClick={onClick}
        title={
          user && (isAdmin(user) || isWccSupportUser(user)) ? versionInfo : ''
        }
        aria-label="Go To Home"
      >
        <img src={icon} alt="Home" />
      </Link>
    </div>
  );
}

export default withSounds({ mouseEnterSound: true })(HomeIcon);
